import * as React from 'react';
import Svg, { Circle, Path } from 'react-native-svg';

import { ds } from '@/components/lib/design.system';

const SvgComponent = props => (
    <Svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <Path d="M12 8.5V13" stroke={props.color ?? ds.colorValue.icon.warning} strokeWidth="1.75" />
        <Path
            d="M18.5371 12.197L16.0958 8.20214L16.0958 8.20213C14.7416 5.9862 14.0645 4.87823 13.1928 4.50051C12.4318 4.17075 11.5682 4.17075 10.8072 4.50051C9.93553 4.87823 9.25844 5.9862 7.90425 8.20214L5.46292 12.197C4.00401 14.5843 3.27456 15.778 3.36058 16.7614C3.43558 17.6188 3.87521 18.4027 4.5677 18.9138C5.36198 19.5 6.76088 19.5 9.55867 19.5H14.4413C17.2391 19.5 18.638 19.5 19.4323 18.9138C20.1248 18.4027 20.5644 17.6188 20.6394 16.7614C20.7254 15.778 19.996 14.5843 18.5371 12.197Z"
            stroke={props.color ?? ds.colorValue.icon.warning}
            strokeWidth="1.75"
        />
        <Circle cx="12" cy="15.75" r="1.25" fill={props.color ?? ds.colorValue.icon.warning} />
    </Svg>
);

export default SvgComponent;
